var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.142,
    height: 25.594,
    viewBox: "0 0 101.142 25.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.032,
    y1: 0.012,
    x2: 0.954,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#29b3eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21edba"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.316,
    y1: -1.299,
    x2: 1.545,
    y2: 3.382,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.583,
    y1: -2.476,
    x2: 1.278,
    y2: 2.204,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1579",
    "data-name": "Group 1579",
    transform: "translate(-40 -81.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1578",
    "data-name": "Group 1578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M54.69,81.2H41.3L40,82.5v23l1.3,1.3H54.69l1.3-1.3v-23Zm-1.3,23h-10.8V83.8h10.8Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M51.95,90.39H49.289V87.729H46.7V90.39H44.036v2.592H51.95Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M46.7,100.436h2.592V97.776H51.95V95.183H44.036v2.592H46.7Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M82.735,84.635v7.813h3.559V84.635h3.1v18.73h-3.1V95.231H82.735v8.134h-3.1V84.635Zm16.026,18.73V84.635h8.215v2.729h-5.111V92.5h4.281v2.729h-4.281v5.4h5.191v2.729Zm25.472-16H121.1v16H118v-16h-3.131V84.635h9.365Zm13.083,11.827h-3.425l-.669,4.174h-3l3.478-18.73h3.906l3.532,18.73h-3.157Zm-.4-2.569L135.6,88.3l-1.311,8.321Zm-73-11.987v2.729h9.365V84.635Zm0,7.792h3.141v10.938h3.1V92.427h3.121V89.7H63.916Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheta);
export default __webpack_public_path__ + "static/media/theta.3a0f93ba58b53b7e7e08e6db2548cd6f.svg";
export { ForwardRef as ReactComponent };